import React, { useState, useEffect, useRef, useCallback } from 'react'
import 'devextreme/data/odata/store'
import DataGrid, {
  Column,
  Paging,
  FilterRow,Editing,
  Form,
  SearchPanel,
  RequiredRule
} from 'devextreme-react/data-grid'
import { Item, EmailRule } from 'devextreme-react/form'
import TenantService from "../../api/tenant.service"
import DOMPurify from 'dompurify';
import Toast from 'components/Toast';
import { useHistory } from "react-router";
import { Popup as AssignTenantPopup } from 'devextreme-react/popup';
import {Tooltip} from 'devextreme-react';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer'
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import {
  Form as DxForm,
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule as DxFormRequiredRules,
  EmailRule as DxEmailRule,
  StringLengthRule as DXStringLengthRule,
  PatternRule
} from 'devextreme-react/form';

export default function App() {
  const [data, setData] = useState([]);
  const dropDataGridRef = useRef();
  const [loadingText, setloadingText] = useState('Loading...');
  const [showPopup, setShowPopup] = useState(false)
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const formRef = useRef();
  const dxFormRef = useRef();
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000,
  });
  const [formData, setFormData] = useState({
    tenantName: "",
    email: "",
    mobileNumber: "",
    password: "",
    firstName: "",
    lastName: ""
  });

  function getData() {
    TenantService.getTenants().then((value) => {
      let response=value.data
      setData(response.data)
    })
  }

  function onRowInserted(e) {
    TenantService.addTenant(e.data.name, e.data.email, e.data.password, e.data.firstName, e.data.lastName, e.data.mobileNumber).then((tenant) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: tenant?.status===200 ? 'success' : 'error', 
        status: tenant?.data?.status ? tenant?.data?.status : tenant.status,
        message: tenant?.data?.message ? tenant.data.message : tenant.message,
      });
      
    })
  }

  function rulesText() {
    return (
      <>
        Edit
      </>
    )
  }

  function buttonColor(e) {
    if (((e.column.caption === 'Rules')) && e.rowType !== "header") {
      e.cellElement.style.color = "#ffc72c";
      e.cellElement.style.setProperty('cursor', 'pointer', 'important')
    }
  }

  function showInfo(e) {
     if (e.column.caption === 'Rules') {
      e.cellElement.style.color = "#337ab7";
      history.push({
        pathname: `/behaviors/rule/available/${e.data.id}`,
        state3: {
          response: ""
        }
      })
    }
  }

  useEffect(() => {
    getData()
  }, []);

  function handleCloseDrawer(){
    setEditingRow(null)
    setFormData({
      tenantName: "",
      email: "",
      mobileNumber: "",
      password: "",
      firstName: "",
      lastName: ""
    })
    setIsOpen(false)
  }

  function onAddRow() {
    const { tenantName, email, mobileNumber, password, firstName, lastName} = formData
    TenantService.addTenant(tenantName, email, password, firstName, lastName, mobileNumber).then((tenant) => {
      getData()
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: tenant?.status===200 ? 'success' : 'error', 
        status: tenant?.data?.status ? tenant?.data?.status : tenant.status,
        message: tenant?.data?.message ? tenant.data.message : tenant.message,
      });
      
      // Close drawer after successful save
      if (tenant?.status === 200) {
        handleCloseDrawer();
      }
    })
  }

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const result = dxFormRef.current?.validate?.();
    if (result?.isValid) {
      // if(formData && formData?.id){
      //   onRowUpdate()
      // }else{
      //   onAddRow()
      // }
      onAddRow()
    }
  },[formData]);

  function handleSave(){
    formRef.current?.requestSubmit();
  }

  function onSubmit(data){
    setEditingRow(null)
    setIsOpen(false)
  }

  function handleInputChange(e, name) {
    // const value = name === "name" ? e?.value : e?.selectedItem;
    const value = e?.value;
    if (!value) return;
    setEditingRow(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const onHiding = function() {
    setShowPopup(false)
  }
  return (
    <>
    <div className='headerHeadingPage'>
		  <div className='pageFullWidthEvents'>
        <h5 className='marginZeroEvents'>
          <b>Tenants</b>
        </h5>
      <Toast
        setParentToastConfig={setToastConfig}
        toastBody={toastConfig}
      />
      <DataGrid
        ref={dropDataGridRef}
        showColumnLines={false}
        showRowLines={true}
        onCellClick={showInfo}
        onCellPrepared={buttonColor}
        onRowInserted={onRowInserted}
        allowColumnResizing={true}
        height={'calc(100vh - 51px)'}
        noDataText={loadingText}
        onColumnsChanging={function (e) {
          if(e.component?.getDataSource()?._totalCount <= 0 && data.length > 0){
            setloadingText('No Data');
          }
        }}
        onToolbarPreparing={(e) => {
          e.toolbarOptions.items = e.toolbarOptions.items.filter(
            (item) => item.name !== 'addRowButton'
          );
        
          e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: '',
              text: '',
              stylingMode: 'text',
              // onClick: () => e.component.addRow(),
              onClick: () => setIsOpen(true),
              elementAttr: {
                id: 'addTenantButton',
              },
              template: (buttonData, buttonElement) => {
                const container = document.createElement('div');
                container.style.display = 'flex';
                container.style.alignItems = 'center';
                container.style.justifyContent = 'center';
              
                container.innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                       viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                `;
                container.style.color = 'var(--app-text)';

                buttonElement.appendChild(container);
              }
              
            },
          });
        }}
        
        dataSource={data}>
        <Paging enabled={false} key={'paging'}/>
         <Editing
          allowUpdating={false}
          allowDeleting={false}
          allowAdding={true}
          use-icons={true}
          mode="popup"
          // texts={{
          //   addRow: 'Add a Tenant',
          // }}
        >
          <Form colCount={1}>
            <Item dataField="name" >
              <RequiredRule message="Name is required" />
            </Item>
            <Item dataField="email">
              <RequiredRule message="Email is required" />
              <EmailRule message="Email is invalid" />
            </Item>
            <Item
              dataField="mobileNumber"
              helpText="Please provide a phone number that begins with a plus sign and includes the corresponding country code."
            >
              <RequiredRule message="Mobile Number is required" />
            </Item>
            <Item dataField="password" >
              <RequiredRule message="Password is required" />
            </Item>
            <Item dataField="firstName" >
              <RequiredRule message="First name is required" />
            </Item>
            <Item dataField="lastName" >
              <RequiredRule message="Last name is required" />
            </Item>
          </Form>
        </Editing> 
        <FilterRow visible="true" apply-filter="true" />
        <SearchPanel visible="true" width="240" placeholder="Search..." />
        <Column
          dataField={DOMPurify.sanitize('name')}
          caption={"Tenant Name"}
          width={390}
          hidingPriority={8}
        >
          <RequiredRule />
        </Column>
        <Column
          dataField={DOMPurify.sanitize('firstName')}
          caption={"First Name"}
          visible={false}
        >
        </Column>
        <Column
          dataField={DOMPurify.sanitize('lastName')}
          caption={"Last Name"}
          visible={false}
        >
        </Column>
        <Column
          dataField={DOMPurify.sanitize('email')}
          caption={"Email"}
          visible={false}
        >
        </Column>
        <Column
          dataField={`mobileNumber`}
          caption={"Mobile Number"}
          width={300}
          hidingPriority={8}
        >
          <PatternRule
            pattern={/^\+(?:[0-9] ?){6,14}[0-9]$/}
            message={'Your phone must have "+11234567890" format!'}
          />
        </Column>
        <Column
          dataField={DOMPurify.sanitize('password')}
          caption={"Password"}
          visible={false}
        >
          <PatternRule
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
            message="Minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
          />
        </Column>
        <Column
          dataField={DOMPurify.sanitize('type')}
          caption={'Role'}
          allowSorting={false}
          allowFiltering={false}
        >
        </Column>
        <Column
          caption={'Rules'}
          cellRender={rulesText}
        ></Column>
      </DataGrid>
      <Tooltip
        target="#addTenantButton"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        position="bottom"
      >
        <div className="custom-tooltip">Add a Tenant</div>
      </Tooltip>
      <AssignTenantPopup
          visible={showPopup}
          onHiding={onHiding}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={false}
          showTitle={true}
          title="Add Behavior"
          container=".dx-viewport"
          width={500}
          height={350}
        >
      </AssignTenantPopup>
      </div>
      </div>


      <SlidingDrawer 
          title={`${formData?.id ? "Edit" : "Add"} Tenant`}
          isOpen={isOpen} 
          onClose={handleCloseDrawer}
          handleSave={handleSave}
          formData={formData}
          prevData={editingRow}
        >
          {isOpen &&
          <form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>
            <div>
              <DxForm
                formData={formData}
                onFieldDataChanged={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    [e.dataField]: e.value,
                  }));
                }}
                onInitialized={(e) => {
                  dxFormRef.current = e.component;
                }}
                labelLocation="top"
                showColonAfterLabel={false}
                showValidationSummary={false}
              >
                <GroupItem colCount={1}>
                  <SimpleItem
                    dataField="tenantName"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                    }}
                    validationRules={[{ type: 'required', message: 'Tenant Name is required' }]}
                  >
                    <Label text="Tenant Name" isRequired />
                  </SimpleItem>
    
                  <SimpleItem
                    dataField="email"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                      mode: 'email',
                      name: 'fake_email_field',
                      autoComplete: 'off'
                    }}
                  >
                    <Label text="Email" isRequired />
                    <DxFormRequiredRules message="Email is required" />
                    <DxEmailRule message="Invalid email format" />
                  </SimpleItem>
    
                  <SimpleItem
                    dataField="mobileNumber"
                    editorType="dxTextBox"
                    editorOptions={{
                      mode: 'tel',
                      inputAttr: {
                        name: 'fake_mobile',
                        autoComplete: 'new-password'
                      }
                    }}
                    helpText="Please provide a phone number that begins with a plus sign and includes the corresponding country code."
                  >
                    <Label text="Mobile Number" />
                    <DxFormRequiredRules message="Mobile Number is required" />
                    <PatternRule 
                      pattern={/^\+(?:[0-9] ?){6,14}[0-9]$/}
                      message='Your phone must have "+11234567890" format!'
                    />
                  </SimpleItem>
                  
                  <SimpleItem
                    dataField="password"
                    editorType="dxTextBox"
                    editorOptions={{ 
                      mode: 'password', 
                      inputAttr: {
                        name: 'fake_pass',
                        autoComplete: 'new-password'
                      }
                    }}
                  >
                    <Label text="Password" />
                    <DxFormRequiredRules message="Password is required" />
                    <DXStringLengthRule
                      min={8}
                      max={20}
                      message="Password must be between 8 and 20 characters long"
                    />
                    <PatternRule
                      pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                      message="Minimum 8 characters, with at least 1 uppercase, 1 lowercase, 1 number, and 1 special character"
                    />
                  </SimpleItem>

                  <SimpleItem
                    dataField="firstName"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                    }}
                    validationRules={[{ type: 'required', message: 'First Name is required' }]}
                  >
                    <Label text="First Name" isRequired />
                  </SimpleItem>

                  <SimpleItem
                    dataField="lastName"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                    }}
                    validationRules={[{ type: 'required', message: 'Last Name is required' }]}
                  >
                    <Label text="Last Name" isRequired />
                  </SimpleItem>
    
                </GroupItem>
              </DxForm>
            </div>
          </form>
          }
      </SlidingDrawer>
    </>
  );
}
